import { render } from "./AddBudget.vue?vue&type=template&id=bfce0cca"
import script from "./AddBudget.vue?vue&type=script&lang=js"
export * from "./AddBudget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__